import { render, staticRenderFns } from "./AllBuybackRecords.vue?vue&type=template&id=a08d90b2&scoped=true&"
import script from "./AllBuybackRecords.vue?vue&type=script&lang=js&"
export * from "./AllBuybackRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d90b2",
  null
  
)

export default component.exports